import { render, staticRenderFns } from "./SourceDistribution.vue?vue&type=template&id=605f77d2&scoped=true"
import script from "./SourceDistribution.vue?vue&type=script&lang=js"
export * from "./SourceDistribution.vue?vue&type=script&lang=js"
import style0 from "./SourceDistribution.vue?vue&type=style&index=0&id=605f77d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f77d2",
  null
  
)

export default component.exports